var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"options":_vm.options,"placeholder":_vm.placeholder,"fieldNames":{ label: 'name', value: 'id', children: 'values' },"allowClear":false},on:{"change":_vm.onChange},model:{value:(_vm.defaultProvinceCity),callback:function ($$v) {_vm.defaultProvinceCity=$$v},expression:"defaultProvinceCity"}})
}
var staticRenderFns = []

export { render, staticRenderFns }